import React, { useState } from 'react';
import { TEXT, TEXT2, TEXT3, BLUE, SUCCESS, FONT } from '../../shared';

const AGENT_COLORS = [
  '#0EA5E9', '#9333EA', '#10B981', '#F59E0B', '#EF4444', '#0D9488', '#6366F1',
];

function AgentSection({ agent, index, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const color = AGENT_COLORS[index % AGENT_COLORS.length];

  return (
    <div style={{
      border: '1px solid rgba(255,255,255,0.60)',
      borderRadius: 12,
      overflow: 'hidden',
      background: 'rgba(255,255,255,0.45)',
    }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: 10,
          padding: '10px 14px', border: 'none', background: 'transparent',
          cursor: 'pointer', fontFamily: FONT, textAlign: 'left',
        }}
      >
        <div style={{
          width: 28, height: 28, borderRadius: 8, flexShrink: 0,
          background: `${color}18`, border: `1px solid ${color}30`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
          </svg>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: TEXT, letterSpacing: '-0.01em' }}>
            {agent.agentName || agent.agent || `Agent ${index + 1}`}
          </div>
          {agent.role && (
            <div style={{ fontSize: 11, color: TEXT3, marginTop: 1 }}>{agent.role}</div>
          )}
        </div>
        {agent.confidence != null && (
          <span style={{
            fontSize: 10, fontWeight: 700, color: agent.confidence > 0.8 ? SUCCESS : agent.confidence > 0.5 ? '#F59E0B' : TEXT3,
            background: agent.confidence > 0.8 ? `${SUCCESS}15` : 'rgba(180,205,235,0.25)',
            borderRadius: 999, padding: '2px 7px', flexShrink: 0,
          }}>
            {Math.round(agent.confidence * 100)}% confident
          </span>
        )}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={TEXT3} strokeWidth="2"
          style={{ flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && agent.contribution && (
        <div style={{ padding: '0 14px 12px 52px', fontSize: 13, color: TEXT2, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
          {agent.contribution}
        </div>
      )}
    </div>
  );
}

export default function SwarmResultWidget({ agents }) {
  if (!agents?.length) return null;

  return (
    <div style={{
      background: 'rgba(255,255,255,0.45)',
      backdropFilter: 'blur(22px)',
      WebkitBackdropFilter: 'blur(22px)',
      border: '1px solid rgba(255,255,255,0.58)',
      borderRadius: 18,
      padding: '14px 14px',
      boxShadow: '0 1px 0 rgba(255,255,255,0.9) inset, 0 8px 24px -10px rgba(11,107,211,0.14)',
      fontFamily: FONT,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 12 }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
        <span style={{ fontSize: 12, fontWeight: 700, color: TEXT, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Swarm — {agents.length} agents
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {agents.map((agent, i) => (
          <AgentSection key={i} agent={agent} index={i} defaultOpen={i === 0} />
        ))}
      </div>
    </div>
  );
}
